import { render, staticRenderFns } from "./ModalEditFormItem.vue?vue&type=template&id=2dd19296&scoped=true"
import script from "./ModalEditFormItem.vue?vue&type=script&lang=js"
export * from "./ModalEditFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd19296",
  null
  
)

export default component.exports